import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';

import { CaseManagementReceivedMethodAddRoutingModule } from './case-management-received-method-add-routing.module';
import { CaseManagementReceivedMethodAddComponent } from './case-management-received-method-add.component';
import { DialogModule } from '@syncfusion/ej2-angular-popups';
import { SharedModule } from 'src/app/shared/shared.module';


@NgModule({
  declarations: [
    CaseManagementReceivedMethodAddComponent
  ],
  imports: [
    CommonModule,
    CaseManagementReceivedMethodAddRoutingModule,
    DialogModule,
    SharedModule,
  ],
  exports:[
    CaseManagementReceivedMethodAddComponent
  ]
})
export class CaseManagementReceivedMethodAddModule { }
